import React from 'react';
import { BadgeCheckIcon, FileCheck2Icon, GiftIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
const perks = [{
  icon: ZapIcon,
  label: 'Instant refund'
}, {
  icon: FileCheck2Icon,
  label: 'No forms to fill'
}, {
  icon: GiftIcon,
  label: 'Keep the bonuses'
}];
export function GuaranteeSection() {
  return <section className="bg-ink px-5 py-20" data-id="element-76" data-mp="eu8uh3r5v8h5">
      <div className="mx-auto max-w-3xl border-t-8 border-gold bg-white p-8 text-center shadow-2xl sm:p-14" data-id="element-77" data-mp="jsirzl0cyl5x">
        <p className="inline-flex items-center gap-2 bg-gold-dark px-4 py-2 text-xs font-bold uppercase tracking-widest text-white" data-id="element-78" data-mp="ntvzdzj3mwey">
          <BadgeCheckIcon className="h-4 w-4" data-id="element-79" data-mp="slvvfgw1t569" /> Zero risk · 100% protected
        </p>
        <ShieldCheckIcon className="mx-auto mt-7 h-20 w-20 text-gold-dark" strokeWidth={1.4} data-id="element-80" data-mp="xk72jjuyl1ks" />
        <h2 className="mt-6 font-display text-5xl font-bold uppercase leading-none text-ink sm:text-6xl" data-id="element-81" data-mp="12klbr58aqhke">
          7-day <span className="text-gold-dark" data-id="element-82" data-mp="17id0xrhk3pkw">guarantee</span>
        </h2>
        <p className="mx-auto mt-6 max-w-lg text-lg font-medium text-slate-600" data-id="element-83" data-mp="25syjcpiwxcfn">
          Open everything. Use the material. Put it to the test on court.
        </p>
        <p className="mt-5 text-2xl font-bold leading-tight text-ink" data-id="element-84" data-mp="1vthg0er4vamu">
          If Tennis Ready™ doesn’t transform the way you coach,{' '}
          <span className="text-gold-dark" data-id="element-85" data-mp="1rth1yv7y51gb">
            we’ll refund every cent — no questions asked.
          </span>
        </p>
        <div className="mt-7 flex flex-wrap justify-center gap-x-5 gap-y-3 text-xs font-bold text-ink" data-id="element-86" data-mp="2okiyopu1bob4">
          {perks.map(({
          icon: Icon,
          label
        }) => <span key={label} className="flex items-center gap-1.5" data-id="element-87" data-mp="2erk1ijkh2pfw">
              <Icon className="h-4 w-4 text-gold-dark" data-id="element-88" data-mp="2ar9t7097jmxv" /> {label}
            </span>)}
        </div>
        <p className="mt-6 inline-block border border-gold/40 bg-gold-wash px-4 py-2 text-xs font-bold uppercase tracking-widest text-gold-deeper" data-id="element-89" data-mp="379fxn70dn4zo">
          Refund rate below 1%
        </p>
      </div>
    </section>;
}